import React from "react";
import { ReactComponent as AdminHelpSvg } from "../../assets/icons/adminhelp.svg";

export default function AdminHelpIcon({ size = 20, className = "" }) {
  const iconSize = typeof size === "number" ? `${size}px` : size;

  return (
    <AdminHelpSvg
      className={className}
      aria-hidden="true"
      focusable="false"
      style={{
        width: iconSize,
        height: iconSize,
        display: "inline-block",
        verticalAlign: "-0.125em",
        flexShrink: 0,
      }}
    />
  );
}
